import { Col, Form, Row } from "antd";
import { useState } from "react";
import AutoCalcSwitch from "../../../../components/form/autoCalcSwitch";
import InputNum from "../../../../components/form/inputNum";
import InputPrice from "../../../../components/form/inputPrice";
import DividerLine from "../../../../components/lineSplit";
import TaxFlowStore, { TaxFlow } from "../../../../contexts/taxFlowStore";
import _t from "../../../../lang/translate";
import { Strict } from "../../../../types/utilTypes";
import format from "../../../../utilities/formatNumbers";
import { safeNum } from "../../../../utilities/number";
import TaxInvoiceActions from "../admin/taxInvoiceActions";
import TaxReceiptActions from "../admin/taxReceiptActions";
import RegistrationFee from "./taxFlowRegistrationFee";
import CopyableContent from "../../../../components/copyableContent";

export default function TaxFlowOptimization() {

  return (
    <div className="p-1">
      <Row gutter={[16, 16]}>
        <Col order={1} span={24} xl={{ span: 12, order: 0 }} xxl={14}>
          <RegistrationFee />
        </Col>
        <Col order={0} span={24} xl={{ span: 12, order: 1 }} xxl={10}>
          <Optimization />
        </Col>
      </Row>
    </div>
  )
}

function Optimization() {
  const { taxFlow, setTaxFlow, setLocks, dirty, caseLocked } = TaxFlowStore.useContainer()
  const [loading, setLoading] = useState(false)
  const offer = taxFlow.offer;

  function handleRegFeeChange(val: unknown) {
    setTaxFlow((prev) => ({
      ...prev,
      registrationFee: {
        ...prev.registrationFee,
        registrationFee: safeNum(val) ?? null,
      },
    }))
  }
  function handleCollateralFeeChange(val: unknown, key: keyof Strict<Strict<TaxFlow>['offer']>['collateral']) {
    setTaxFlow((prev) => ({
      ...prev,
      offer: {
        ...prev.offer,
        collateral: {
          ...prev.offer?.collateral,
          [key]: safeNum(val) ?? undefined,
        }
      }
    }))
  }
  function handleLicensePlateFeeChange(val: unknown) {
    setTaxFlow((prev) => ({
      ...prev,
      offer: {
        ...prev.offer,
        licensePlateFee: safeNum(val) ?? undefined,
      }
    }))
  }
  function handleCaseFeeChange(val: unknown) {
    setTaxFlow((prev) => ({
      ...prev,
      offer: {
        ...prev.offer,
        caseFee: safeNum(val) ?? undefined,
      }
    }))
  }


  return (
    <div className="border-light border-radius bg-light p-1">
      <h3 className="mb-1">{_t("evaluation")}</h3>
      <Form labelCol={{ xs: 24, lg: 10, xl: 8, className: "text-left" }}
        wrapperCol={{ xs: 24, lg: 14, xl: 16 }}
        colon={false}
      >
        <Form.Item label={_t("registration_fee")}
          extra={
            safeNum(taxFlow.projected?.estimatedRegistrationFee) !== undefined && (
              <small className="muted mt-02">
                Proj. 2027: {format.price(taxFlow.projected?.estimatedRegistrationFee)}
              </small>
            )
          }
        >
          <InputNum
            min={0} className="bg-white no-border" suffix="Kr."
            value={taxFlow?.registrationFee?.registrationFee ?? undefined}
            onChange={handleRegFeeChange}
          />
        </Form.Item>

        <Row className="flex-nowrap">
          <Col flex="auto">
            <Form.Item label={_t("collateral")}>
              <InputNum min={0} className="bg-white no-border" suffix="Inkl. moms"
                disabled={taxFlow.autoCalc?.collateralFee}
                value={offer?.collateral?.total ?? undefined}
                onChange={(v) => handleCollateralFeeChange(v, 'total')}
              />
            </Form.Item>
          </Col>
          <Col flex="31px">
            <AutoCalcSwitch value={taxFlow.autoCalc?.collateralFee} onChange={v => setLocks({ collateralFee: v })} />
          </Col>
        </Row>

        <Row className="flex-nowrap">
          <Col flex="auto">
            <Form.Item label={_t("plade_nr_fee")}>
              <InputNum min={0} className="bg-white no-border" suffix="Kr."
                value={offer?.licensePlateFee ?? undefined}
                onChange={handleLicensePlateFeeChange}

              />
            </Form.Item>
          </Col>
          <Col flex="31px" />
        </Row>

        <Form.Item label={_t("fee")}>
          <InputNum suffix={"Inkl. moms"} min={0} className="bg-white no-border"
            value={offer?.caseFee ?? undefined}
            onChange={handleCaseFeeChange}
          />
        </Form.Item>
        <DividerLine />
        <Form.Item label={_t("total_price")}>
          <CopyableContent contentToCopy={offer?.totalPrice?.toFixed(0) ?? ""}>
            <span>{format.price(offer?.totalPrice)}</span>
          </CopyableContent>
        </Form.Item>
      </Form>
      <DividerLine fluid smallFluid />
      <TaxInvoiceActions setLoading={setLoading} loading={loading} dirty={dirty} disabled={caseLocked} />
      <DividerLine fluid smallFluid />
      <TaxReceiptActions setLoading={setLoading} disabled={caseLocked} />
    </div>
  )
}
